import { useState, useEffect, useRef } from "react";
import "./MoreOption.scss";
export interface MoreOptionProps {
  className?: string;
  onClick?: () => void;
  children?: any;
  ariaLabel?: string;
  customIcon?: any;
  mainButtonLabel?: string
  btnClass?: string;
  disabled?: boolean;
  labelId?: string;
}

const MoreOption = ({
  className,
  onClick,
  children,
  ariaLabel,
  customIcon = "ellipsis",
  mainButtonLabel,
  btnClass,
  disabled,
  labelId
}: MoreOptionProps) => {

  const [click, setClick] = useState(false);
  const modalRef = useRef<any>(null);
  const lastClickedButtonRef = useRef<any>(null);

  const handleClickOutside = (event: any) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setClick(false);
      lastClickedButtonRef.current?.focus();
    }
  };
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      setClick(false);
      lastClickedButtonRef.current?.focus();
    }
  };

  useEffect(() => {
    if (click) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleKeyDown);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [click]);
 
  useEffect(() => {
    const menuContainer = modalRef.current;

    const handleFocusOut = (event: FocusEvent) => {
      if (
        menuContainer &&
        !menuContainer.contains(event.relatedTarget as Node)
      ) {
        setClick(false);
      }
    };

    if (click && menuContainer) {
      menuContainer.addEventListener("focusout", handleFocusOut);
    }

    return () => {
      if (menuContainer) {
        menuContainer.removeEventListener("focusout", handleFocusOut);
      }
    };
  }, [click]);

  return (
    <div
      className={`moreOptions${className ? " " + className : ""}`}
      ref={modalRef}
    >
      <button
        onClick={() => {
          setClick(!click);
          onClick?.();
        }}
        aria-label={
          mainButtonLabel && mainButtonLabel !== ""
            ? mainButtonLabel
            : ariaLabel
        }
        className={`optionButton${btnClass ? " " + btnClass : ""}`}
        disabled={disabled}
        tabIndex={0}
        aria-haspopup="true"
        aria-expanded={click}
        aria-labelledby={`firstName-${labelId} lastName-${labelId}`} 
        ref={lastClickedButtonRef}
      >
        {mainButtonLabel ?? ""}
        <aui-icon
          block={true}
          svgclass={`aui-icon-${customIcon}`}
          pathclass={`aui-path-${customIcon}`}
          icon={customIcon}
          svgwidth="20"
          svgheight="20"
        ></aui-icon>
      </button>
      {click && (
        <button
          className="drop"
          onClick={() => setClick(!click)}
          role="menu"
          aria-label="More options"
        >
          {children}
        </button>
      )}
    </div>
  );
};
export default MoreOption;
